export enum FileType {
    Image = 'Image',
    Audio = 'Audio',
    Video = 'Video'
}